import { ChangeDetectorRef, Component, EventEmitter, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { DocumentService } from '../../../document/document.service';
import { MediaBankService } from '../../../media-bank/media-bank.service';
import {
    IWidgetTagOptionTypesItem,
    WidgetTagOptionType,
    WidgetTagOptionTypes,
} from '@fi-shared/types/widget-tag-option-type';
import { AppTextService } from '@fi-shared/app-text';
import { DropdownSettingsModelV2 } from '@fi-shared/dropdown';
import { SortType } from '@fi-shared/types/sort-type';
import { WidgetSettingsControlBase } from '../control-base';

interface IWidgetTagOptionTypeOption {
    Id: number;
    Name: string;
    i: number;
}

@Component({
    selector: 'widget-settings-control-listing',
    templateUrl: './listing.component.html',
    styleUrls: ['./listing.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'widget-settings-control-listing' },
    standalone: false,
})
export class WidgetSettingsControlListingComponent extends WidgetSettingsControlBase implements OnInit {
    IsTagsSelectable: boolean = true;
    TagsDataSource: Promise<any>;
    tagOptionTypesListData = new DropdownSettingsModelV2<IWidgetTagOptionTypeOption>({
        orderBy: 'i',
    });
    SortingTypes: { value; label }[];
    availableTags = [];

    constructor(
        injector: Injector,
        private documentService: DocumentService,
        private mediaBankService: MediaBankService,
        private appTextService: AppTextService,
        private cdr: ChangeDetectorRef,
    ) {
        super(injector);
    }

    ngOnInit() {
        this._initTagsDataSource();
        this._initTagOptionsDropdown();
        this._initWidgetTagOptionTypeCheck();
        this._initSortingType();
    }

    protected _initTagsDataSource() {
        const promisePull: Promise<any>[] = [
            this.documentService.GetDocumentTagsByUserAccessRights(),
            this.mediaBankService.getMediaBankFileTagsByUserAccessRights(),
        ];

        this.TagsDataSource = new Promise<any>((resolve) => {
            Promise.all(promisePull).then((results) => {
                let tags = results[0];
                results[1].forEach((tag) => {
                    if (!tags.filter((existingTag) => tag.Id === existingTag.Id).length) {
                        tags.push(tag);
                    }
                });
                resolve(tags);
            });
        });

        this.TagsDataSource.then((tags) => {
            this.availableTags = tags;
            this.cdr.markForCheck();
        });
    }

    protected _initTagOptionsDropdown() {
        if (!this.Settings.WidgetTagOptionType) {
            this.Settings.WidgetTagOptionType = WidgetTagOptionType.AnySelected;
        }

        this.tagOptionTypesListData.setDataSet(this.getTagListData());
    }

    private getTagListData(): IWidgetTagOptionTypeOption[] {
        return WidgetTagOptionTypes.reduce(
            (result: IWidgetTagOptionTypeOption[], current: IWidgetTagOptionTypesItem, i: number) => {
                if (!(this.isStartPage === true && current.StartPage === false)) {
                    result.push({
                        Id: current.Id,
                        Name: this.appTextService.get(current.TextId).toLowerCase(),
                        i: i,
                    });
                }

                return result;
            },
            [],
        );
    }

    _onWidgetTagOptionTypeChangeEmitter = new EventEmitter();

    _onWidgetTagOptionTypeChange($event) {
        this._onWidgetTagOptionTypeChangeEmitter.emit($event);
        super.settingsPropertyOnChange();
    }

    onNumberOfRecordsChange($event) {
        this.Settings.NumberOfRecordsToTake = $event;
        super.settingsPropertyOnChange();
    }

    _initWidgetTagOptionTypeCheck() {
        //used to store selected tags when TagOptionType is "Related"
        let tempSettingsTag = [];

        const CheckIsTagsSelectable = (oldTagOptionsType, newTagOptionsType) => {
            this.IsTagsSelectable =
                newTagOptionsType != WidgetTagOptionType.AnyRelated &&
                newTagOptionsType != WidgetTagOptionType.AllRelated &&
                newTagOptionsType != WidgetTagOptionType.All;

            if (oldTagOptionsType == newTagOptionsType) return;

            if (
                newTagOptionsType == WidgetTagOptionType.All ||
                newTagOptionsType == WidgetTagOptionType.AnyRelated ||
                newTagOptionsType == WidgetTagOptionType.AllRelated
            ) {
                tempSettingsTag = this.widgetControl.TagIds.slice();
                this.widgetControl.TagIds.length = 0;
            } else if (
                oldTagOptionsType == WidgetTagOptionType.All ||
                oldTagOptionsType == WidgetTagOptionType.AnyRelated ||
                oldTagOptionsType == WidgetTagOptionType.AllRelated
            ) {
                this.widgetControl.TagIds = tempSettingsTag.slice();
                tempSettingsTag.length = 0;
            }
        };

        let oldValue = this.Settings.WidgetTagOptionType;

        CheckIsTagsSelectable(WidgetTagOptionType.AnySelected, this.Settings.WidgetTagOptionType);

        this._onWidgetTagOptionTypeChangeEmitter.subscribe((newValue) => {
            if (oldValue === newValue) {
                return;
            }

            CheckIsTagsSelectable(oldValue, newValue);
            oldValue = newValue;
        });
    }

    _initSortingType() {
        this.SortingTypes = [
            { value: SortType.Alphabetical, label: this.appTextService.get('common.alphabetical') },
            { value: SortType.ReversedAlphabetical, label: this.appTextService.get('common.reversed_alphabetical') },
            { value: SortType.Chronological, label: this.appTextService.get('common.chrono') },
            { value: SortType.ReversedChronological, label: this.appTextService.get('common.reverse_chrono') },
        ];

        if (!this.Settings.SortingType) {
            this.Settings.SortingType = SortType.Alphabetical;
        }
    }
}
